import { render, staticRenderFns } from "./ARadio.vue?vue&type=template&id=8b5303a8"
import script from "./ARadio.vue?vue&type=script&lang=js"
export * from "./ARadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports